import React, { useState } from 'react';
import DataTable from '../../../components/DataTable';
import EditModal from '../../../components/EditModal';
import { editDonorSchema } from '../../../formData/editDonorSchema';
import { showSuccess } from '../../../components/showSuccess';
import Tooltip from '../../../components/Tooltip';
import DownClickablePopup from '../../../components/DownClickablePopup';
import DynamicForm from '../../../components/dynamicForm';
import { donationFilterSchema } from '../../../formData/donationFilterSchema';

let sampleData = [
  {
    id: '010101',
    status: 'Completed',
    statusColor: '#16a34a',
    customer: 'John Doe',
    contact: 'johndoe@gmail.com\n+00 0000000000',
    time: '04/08/2025 08:00am',
    amount: '$1000.00',
    fee: '$100.00',
    net: '$900.00',
    modifier: 'Match Fee',
    method: 'AID PAY CC'
  },
  {
    id: '010102',
    status: 'Pending',
    statusColor: '#facc15',
    customer: 'Jane Smith',
    contact: 'jane@domain.com\n+11 1111111111',
    time: '04/09/2025 09:15am',
    amount: '$250.00',
    fee: '$25.00',
    net: '$225.00',
    modifier: 'Standard Fee',
    method: 'AID PAY ACH'
  },
  {
    id: '010102',
    status: 'Refunded',
    statusColor: '#6366F1',
    customer: 'Jane Smith',
    contact: 'jane@domain.com\n+11 1111111111',
    time: '04/09/2025 09:15am',
    amount: '$250.00',
    fee: '$25.00',
    net: '$225.00',
    modifier: 'Standard Fee',
    method: 'AID PAY ACH'
  },
  {
    id: '010102',
    status: 'Processing',
    statusColor: '#DC3545',
    customer: 'Jane Smith',
    contact: 'jane@domain.com\n+11 1111111111',
    time: '04/09/2025 09:15am',
    amount: '$250.00',
    fee: '$25.00',
    net: '$225.00',
    modifier: 'Standard Fee',
    method: 'AID PAY ACH'
  },
  {
    id: '010102',
    status: 'Failed',
    statusColor: '#DC3545',
    customer: 'Jane Smith',
    contact: 'jane@domain.com\n+11 1111111111',
    time: '04/09/2025 09:15am',
    amount: '$250.00',
    fee: '$25.00',
    net: '$225.00',
    modifier: 'Standard Fee',
    method: 'AID PAY ACH'
  },
  {
    id: '010102',
    status: 'Rejected',
    statusColor: '#facc15',
    customer: 'Jane Smith',
    contact: 'jane@domain.com\n+11 1111111111',
    time: '04/09/2025 09:15am',
    amount: '$250.00',
    fee: '$25.00',
    net: '$225.00',
    modifier: 'Standard Fee',
    method: 'AID PAY ACH'
  }
  // ... more rows
];
sampleData.map((item, index) => {
  item.id = `00${index + 1}`;
  return item;
});

export default function DonationPage() {
  const [search, setSearch] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editData, setEditData] = useState({});
  const [sortOption, setSortOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const filtered = sampleData.filter(d =>
    d.id.includes(search) || d.customer.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    {
      key: 'id',
      title: 'Donation ID',
      className: styles.statusCell,
      headerClassName: styles.th,
      render: (id, row) => (
        <>

          <div className="flex items-center">
            <Tooltip text={row.status} >
              <span style={{ ...styles.statusDot, backgroundColor: row.statusColor }} />
            </Tooltip>
            <span style={styles.idText}>{row.id}</span>
          </div>
        </>
      )
    },
    { key: 'customer', title: 'Customer Name' },
    { key: 'contact', title: 'Customer Email/Phone Number' },
    { key: 'time', title: 'Donation Time' },
    { key: 'amount', title: 'Donation Amount' },
    { key: 'fee', title: 'Processing Fee' },
    { key: 'net', title: 'Net Amount' },
    { key: 'modifier', title: 'Payment Modifier' },
    { key: 'method', title: 'Payment Method' },
    {
      key: 'actions',
      title: 'Action',
      className: styles.actionsCell,
      render: (_, row) => (
        <>
          <button style={styles.actionBtn} title="Edit" onClick={() => handleEdit(row)}>
            <span className="material-icons">edit</span>
          </button>
          <button style={styles.actionBtn} title="Edit">
            <span className="material-icons">visibility</span>
          </button>
          <button style={styles.actionBtn} title="Download">
            <span className="material-icons">download</span>
          </button>
        </>
      )
    }
  ];


  const handleEdit = (row) => {
    setEditData(row);
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  const handleUpdate = async (updatedRow) => {
    console.log('Updated row:', updatedRow);
    // TODO: sync to backend or update local state...
    setModalVisible(false);
    await showSuccess('Donor Details Updated Successfully!');
  };

  const sortOptions = [
    'Donation Time - Ascending',
    'Donation Time - Descending',
    'Donation Amount - Ascending',
    'Donation Amount - Descending',
    'Donation ID - Ascending',
    'Donation ID - Descending',
  ];


  const handleOptionClick = (option) => {
    console.log('Selected option:', option);
    setSelectedOption(option);
  };

  const sortHtml = sortOptions.map((option, index) => (
    <div
      key={index}
      className={`sort-option ${selectedOption === option ? 'sort-option-selected' : ''}`}
      onClick={() => handleOptionClick(option)}
    >
      <span className="sort-option-radio"></span>
      <span>{option}</span>
    </div>
  ))

  const filterHtml = (
    <div style={{ marginTop: 25, padding: 12 }}>
      <DynamicForm
        schema={donationFilterSchema}
        mode="add"
        onAction={(action, data) => {
          if (action === 'clear') { /* reset filters */ }
          if (action === 'apply') { /* apply filters using data */ }
        }}
      />
    </div>
  )

  return (
    <>
      <EditModal
        visible={modalVisible}
        schema={editDonorSchema}
        initialData={editData}
        onClose={handleClose}
        onSubmit={handleUpdate}
      />
      <div style={styles.container}>
        <div style={styles.toolbar}>
          <h1 style={styles.title}>Donation</h1>
          <div style={styles.rightSideFilter}>
            <div style={styles.searchWrapper}>
              <span className="material-icons" style={styles.searchIcon}>search</span>
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            <DownClickablePopup
              popUpTitle={'Filter'}
              filters={filterHtml}>
              <button style={styles.iconBtn}><span className="material-icons">filter_list</span></button>
            </DownClickablePopup>

            <DownClickablePopup
              popUpTitle={'Sort'}
              filters={sortHtml}>
              <button style={styles.iconBtn}><span className="material-icons">sort</span></button>
            </DownClickablePopup>

          </div>
        </div>

        <DataTable data={filtered} columns={columns} rowKey="id" />

      </div>
    </>
  );
}

const styles = {
  container: {
    margin: '0 auto',
    color: '#333'
  },
  title: {
    fontSize: 24,
    marginTop: 0,
    color: '#4a5568'
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
    flexDirection: 'row'
  },
  searchWrapper: {
    position: 'relative',
    width: 240
  },
  searchIcon: {
    position: 'absolute',
    top: '8px',
    left: '8px',
    color: 'rgb(153, 153, 153)'
  },
  searchInput: {
    width: '100%',
    padding: '10px 9px 10px 32px',
    borderRadius: '4px',
    border: '1px solid rgb(204, 204, 204)',
    fontSize: '16px'
  },
  iconBtn: {
    cursor: 'pointer',
    fontSize: '24px',
    color: 'rgb(0, 0, 0)',
    background: '#fff',
    display: 'flex',
    padding: '5px',
    border: 'solid 1px #ccc'
  },

  statusDot: {
    display: 'inline-block',
    width: 12,
    height: 12,
    borderRadius: '50%',
    marginRight: 6
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
    marginRight: 6,
    verticalAlign: 'middle'
  },
  idText: {
    fontSize: 12,
    color: '#000',
    marginTop: 4
  },
  actionBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#555',
    marginRight: 8,
    fontSize: 18
  },
  rightSideFilter: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
};
